module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 12 21",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#facebook",
      toString: function () {
        return this.url;
      }
    }